import { FC, RefObject } from "react";
import { InView } from "react-intersection-observer";
import styles from "./animations.module.scss";

interface SharedAnimationProps {
  render: (
    ref: RefObject<any> | ((node?: Element | null | undefined) => void)
  ) => JSX.Element;
}

const SharedAnimation: FC<SharedAnimationProps> = ({ render }) => {
  return (
    <InView triggerOnce={true}>
      {({ inView, ref, entry }) => {
        if (inView) {
          entry?.target.classList.add(styles.active);
        }
        return <>{render(ref)}</>;
      }}
    </InView>
  );
};

export default SharedAnimation;
